module.exports = __webpack_public_path__ + "img/liberia.a83793c6.svg";